import React, { useEffect, useState } from 'react';
import API, { UPLOADS_URL } from '../api/axios';
import PageBanner from '../components/PageBanner';

const Recognition = () => {
  const [page, setPage] = useState(null);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pageRes, awardsRes] = await Promise.all([
          API.get('/pages/public/recognition'),
          API.get('/awards/public')
        ]);
        setPage(pageRes.data?.data || pageRes.data);
        setAwards(awardsRes.data?.data || []);
      } catch (err) {
        console.error("Error fetching recognition data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <div className="loading-screen"><i className="fas fa-spinner fa-spin"></i></div>;

  return (
    <>
      <PageBanner 
        title={page?.banner_heading || page?.title || 'Recognition'} 
        subtitle={page?.banner_sub_heading || ""} 
        breadcrumbs={[
          { label: 'Home', link: '/' }, 
          { label: 'About Us', link: '/about-us' },
          { label: page?.title || 'Recognition' }
        ]} 
        backgroundImage={page?.banner_image ? `${UPLOADS_URL}/${page.banner_image}` : null} 
        fallback={`${process.env.PUBLIC_URL}/images/page-banners/about-us.jpg`} 
      />

      <div className="container mx-auto px-[15px] py-16">
        {page?.content && (
          <div className="prose max-w-none mb-12 text-gray-600" dangerouslySetInnerHTML={{ __html: page.content }}></div>
        )}

        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-primary mb-4">Awards & Recognitions</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
        </div>

        {awards.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {awards.map((award, idx) => (
              <div key={idx} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden transition hover:-translate-y-1 hover:shadow-md group">
                <div className="aspect-[4/3] overflow-hidden bg-gray-50 flex items-center justify-center">
                  {award.image ? (
                    <img 
                      src={`${UPLOADS_URL}/${award.image}`} 
                      alt={award.name} 
                      className="w-full h-full object-cover transition duration-500 group-hover:scale-110"
                    />
                  ) : (
                    <i className="fas fa-trophy text-6xl text-gray-200"></i>
                  )}
                </div>
                <div className="p-6 text-center border-t border-gray-50">
                  <h3 className="font-bold text-lg text-gray-900 mb-2 leading-tight">{award.name}</h3>
                  {award.year && (
                    <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-bold mb-2">{award.year}</span>
                  )}
                  {award.awarded_by && (
                    <p className="text-gray-600 text-sm">By: {award.awarded_by}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-xl border border-dashed border-gray-300">
            <i className="fas fa-award text-4xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">Awards are being updated. Check back soon!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Recognition;
